/**
 * Participants get a number in their session (1, 2, 3 … in join order). Screens show it
 * before the name — "#7 Asha" — so a trainer can call people out by number.
 * People without a number (previews, older records) show just their name.
 */
export const withNumber = (name, number) => (number ? `#${number} ${name}` : name);

export default withNumber;
